import { defineStore } from 'pinia'
import { removeCommos } from '@/composables/digits';
import { useSkeleton } from './skeleton';
export const useAuth = defineStore('authentication', {
    state: () => {
        return {
            token : '',
            profile : {},
            login : true,
            head : {
                avatar: { value: '...', icon: 'fa fa-unlock-alt', disabled: false },
                wallet: { value: '...', icon: 'fa fa-pencil-square-o', disabled: false },
                score: { value: '...', icon: 'fa fa-phone' }
            }
        }
    },
    actions: {
        getToken(){
            this.token = localStorage.getItem('token')
        },
        async getAuth(){
            const skeleton = useSkeleton()
            this.getToken() 
            skeleton.headerFlag = false;           
            if(this.token){
                const formData = new FormData()
                formData.append('token',this.token)
                let response = await fetch('https://radap.ir/Backend/api/section/follow/auth.php',{
                    method : 'POST',
                    body : formData
                })
                let data = await response.json()
                if(data.auth == true){
                    this.login = true
                    for(const key in data.data){
                        this.profile[key] = data.data[key]
                    }
                    this.setProfile(data.data)
                }else{
                    this.login = false
                }
            }else{
                this.login = false
            }
            skeleton.headerFlag = true;           
        },
        setProfile(information) {
            this.head.avatar.value = information.name + ' ' + information.family;
            this.head.avatar.icon = 'fa fa-user';
            this.head.avatar.disabled = true;
        
            this.head.wallet.value = 0;
            for(let i in information['wallets']){
                if(information['wallets'][i].amount){
                        this.head.wallet.value += Number(removeCommos(information['wallets'][i].amount))
                }
            }
            this.head.wallet.icon = 'fa fa-credit-card';
            this.head.wallet.disabled = false;
        
            this.head.score.value = information.score + ' امتیاز';
            this.head.score.icon = 'fa fa-certificate';
        }
    }
})